import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import CompanyProfile from '../../team/CompanyProfile';

const ProjectsTab = ({ displayUser, isReadOnly, onAddProject }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold text-slate-900">Projects</h2>
        {!isReadOnly && (
          <button
            onClick={onAddProject}
            className="flex items-center space-x-2 rounded-xl bg-slate-900 px-4 py-2 text-white transition-opacity hover:opacity-90"
          >
            <Plus className="h-4 w-4" />
            <span>Add Project</span>
          </button>
        )}
      </div>
      <CompanyProfile organizationData={{ organization: displayUser?.uid || displayUser?.id }} />
    </motion.div>
  );
};

export default ProjectsTab;
